import React, { useEffect, useState } from 'react';
import { adminAPI } from '../services/api';
import { format } from 'date-fns';
import { MagnifyingGlassIcon, TicketIcon } from '@heroicons/react/24/outline';
import badgeTicket from '../assets/icons/badge-ticket.png';
import badgeCheck from '../assets/icons/badge-check.png';
import badgeTag from '../assets/icons/badge-tag.png';
import badgeClock from '../assets/icons/badge-clock.png';
import KPICard from '../components/KPICard';
import styles from './CouponsPage.module.css';

export default function CouponsPage() {
  const [coupons, setCoupons] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search,  setSearch]  = useState('');
  const [statusF, setStatusF] = useState('');

  useEffect(() => {
    adminAPI.getCoupons()
      .then(res => setCoupons(res.coupons || []))
      .catch(console.error)
      .finally(() => setLoading(false));
  }, []);

  const filtered = coupons.filter(c => {
    const q = search.toLowerCase();
    const matchQ = !q || c.code?.toLowerCase().includes(q) ||
      `${c.first_name} ${c.last_name}`.toLowerCase().includes(q) ||
      c.mobile?.includes(q);
    const matchS = !statusF || c.status === statusF;
    return matchQ && matchS;
  });

  const total   = coupons.length;
  const active  = coupons.filter(c => c.status === 'active').length;
  const used    = coupons.filter(c => c.status === 'used').length;
  const expired = coupons.filter(c => c.status === 'expired').length;
  const fmtDate = d => { try { return format(new Date(d), 'dd MMM yyyy'); } catch { return '—'; } };

  return (
    <div>
      <div className="page-header">
        <div><h1>Coupons</h1><p>{total.toLocaleString()} coupons issued in total</p></div>
      </div>

      <div className={styles.kpiRow}>
        <KPICard label="Total Issued" value={total}  badge={badgeTicket} color="#F5C842" />
        <KPICard label="Active"       value={active} badge={badgeCheck}  color="#10B981" />
        <KPICard label="Redeemed"     value={used}   badge={badgeTag}    color="#2B9DD4" />
        <KPICard label="Expired"      value={expired} badge={badgeClock} color="#EF4444" />
      </div>

      <div className={styles.filters}>
        <div className={styles.searchBox}>
          <MagnifyingGlassIcon style={{ width:15, height:15, color:'var(--text-muted)' }} />
          <input className={styles.searchInput} placeholder="Search by code, member name or mobile…" value={search} onChange={e=>setSearch(e.target.value)} />
        </div>
        <div style={{ display:'flex', gap:6 }}>
          {['','active','used','expired'].map(s=>(
            <button key={s} className={`${styles.tab} ${statusF===s?styles.tabActive:''}`} onClick={()=>setStatusF(s)}>
              {s||'All'}
            </button>
          ))}
        </div>
      </div>

      <div className="card" style={{ padding:0, overflow:'hidden' }}>
        <div className="table-wrap" style={{ border:'none', borderRadius:0 }}>
          <table className="data-table">
            <thead><tr><th>Code</th><th>Member</th><th>Type</th><th>Value</th><th>Reason</th><th>Status</th><th>Issued</th></tr></thead>
            <tbody>
              {loading ? Array.from({length:6}).map((_,i)=>(
                <tr key={i}>{[130,160,80,60,140,80,100].map((w,j)=><td key={j}><div className="skeleton" style={{height:14,width:w,borderRadius:5}}/></td>)}</tr>
              )) : filtered.length===0 ? (
                <tr><td colSpan={7}><div className="empty-state"><TicketIcon style={{width:28,height:28}}/><h3>No coupons found</h3><p>Try adjusting your search.</p></div></td></tr>
              ) : filtered.map((c,i)=>(
                <tr key={i}>
                  <td><span className={styles.code}>{c.code}</span></td>
                  <td><div style={{fontWeight:600,fontSize:13}}>{c.first_name} {c.last_name}</div><div style={{fontSize:11,color:'var(--text-muted)'}}>{c.mobile}</div></td>
                  <td style={{textTransform:'capitalize',fontSize:12,color:'var(--text-muted)'}}>{c.type}</td>
                  <td style={{fontWeight:700}}>{c.type==='percentage'?`${c.value}%`:`$${c.value}`}</td>
                  <td style={{fontSize:12,color:'var(--text-muted)',maxWidth:160}}>{c.issue_reason}</td>
                  <td><span className={`badge badge-${c.status==='active'?'active':c.status==='used'?'inactive':'expired'}`}>{c.status}</span></td>
                  <td style={{fontSize:12,color:'var(--text-muted)'}}>{fmtDate(c.issued_at)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
